import { InputType } from '../Enums/InputType';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { RangeNumber } from './RangeNumber';
import { ForceDirection } from '../Enums/ForceDirection';
import { Dictionary } from 'lodash';
import { Attribute } from './Attribute';
import { Misc } from '../Enums/Misc';
import { Style } from '../Enums/Style';
import { FontSize } from '../Enums/FontSize';
import { Para } from '../Enums/Para';
import { Insert } from '../Enums/Insert';

export class HtmlEditorOptions {
  /**
 * Represent Name Of Form Control
 */
  Name:string
   /**  Represent value of the label*/
   LabelValue:string
    /**  Represent Key of the label*/
    LabelKey:string
   /**  Represent value of the labelDescription show under HtmlEditor*/
  LabelDescription:string
  /**
 *   Represent classes to HtmlEditor that allow us to select the HtmlEditor by jquery or javascript 
 */
 
  ExtraClasses:string
  /** Represent value of the Placeholder of HtmlEditor */
  Placeholder:string
  /**To set  value  to HtmlEditor */
  Value:any
  //** Set the MaxLength of characters In HtmlEditor */
  MaxLength?:number
  /**Set the MinLength of characters In HtmlEditor  */
  MinLength?:number
  /**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  HtmlEditor required */
  IsRequired: boolean
  /** Ability to display or hide the label of HtmlEditor */
  HideLabel:  boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
  /**  to set type of view  if textbox is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
CustomValidation: CustomValidation[]=[]
/** to set Direction of HtmlEditor  if HtmlEditor is Arabic or English  */
  ForceDirection: ForceDirection=ForceDirection.English
  /** Set Height For  */
  Height: number=150
  /** Set List of Custom Attribute to HtmlEditor  */
  AttributeList:Attribute[]
   /** Set List of Misc like codeview Or undo Or redo  */
   ToolsList_Misc?: Misc[];
   /** Set List of Style like bold Or italic Or underline Or clear  */
   ToolsList_Style?: Style[];
   /** Set List of FontSize like fontname Or fontsize Or color   */
   ToolsList_FontSize?: FontSize[];
   /** Set List of Para like style Or ul Or ol Or paragraph Or height   */
   ToolsList_Para?: Para[];
   /** Set List of Insert like table Or picture Or link Or video Or hr   */
   ToolsList_Insert?: Insert[];


}